"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = exports.StyledTableRow = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
const StyledTableRow = (0, _styledComponents.default)(({
  children,
  className,
  dataTest
}) => /*#__PURE__*/React.createElement("tr", {
  className: className,
  "data-test": dataTest
}, children)).withConfig({
  displayName: "TableRow__StyledTableRow",
  componentId: "sc-6eyuf0-0"
})(["box-sizing:border-box;width:100%;white-space:nowrap;"]);
exports.StyledTableRow = StyledTableRow;
const TableRow = ({
  dataTest,
  children
}) => /*#__PURE__*/React.createElement(StyledTableRow, {
  dataTest: dataTest
}, children);
var _default = TableRow;
exports.default = _default;